import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const getKycModes = async (productCode: string): Promise<{kycModes: [{mode: string}]}> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/paandu/kyc-modes`,
        method: "get",
        params: {productCode},
    });
    return response.data;
};
